// EXAAR by Freeghost — Main JS

document.addEventListener('DOMContentLoaded', function () {

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  // Video embed handler (for video wall section on non-Liquid pages)
  if (typeof embedVideo === 'undefined') {
    window.embedVideo = function() {
      const input = document.getElementById('vidUrlInput');
      const frame = document.getElementById('embedFrame');
      const iframe = document.getElementById('embedIframe');
      if (!input || !frame || !iframe) return;
      const url = input.value.trim();
      if (!url) return;
      let embedUrl = '';
      if (url.includes('tiktok.com')) {
        const match = url.match(/video\/(\d+)/);
        if (match) { embedUrl = 'https://www.tiktok.com/embed/v2/' + match[1]; iframe.style.minHeight = '560px'; }
      } else if (url.includes('instagram.com')) {
        const match = url.match(/\/(reel|p)\/([A-Za-z0-9_-]+)/);
        if (match) { embedUrl = 'https://www.instagram.com/p/' + match[2] + '/embed/'; iframe.style.minHeight = '520px'; }
      } else if (url.includes('youtube.com') || url.includes('youtu.be')) {
        const match = url.match(/(?:v=|youtu\.be\/)([A-Za-z0-9_-]{11})/);
        if (match) { embedUrl = 'https://www.youtube.com/embed/' + match[1]; iframe.style.minHeight = '360px'; }
      }
      if (embedUrl) {
        iframe.src = embedUrl;
        frame.style.display = 'block';
        frame.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } else {
        alert('Paste a valid TikTok, Instagram Reel, or YouTube link.');
      }
    };
  }

});
